export const JWTTOKEN = 'JWTTOKEN';
export const ACTIVE_REGION = 'ACTIVE_REGION';